import { AdminContext } from './context';

export namespace ContextParsers {
  export class ContextJson {
    admin!: {
      id: number;
      fullName: string;
      email: string;
      username: string;
    };
    permissions!: string[];
    tenantContext!: {
      tenant: string;
      serverPath: string;
    };
    configuration!: {
      currency: string;
      showDispatchTransition: boolean;
      qboEnabled: boolean;
    };
  }

  export function toContext(input: ContextJson): AdminContext {
    return {
      admin: input.admin,
      permissions: input.permissions,
      tenantContext: {
        serverPath: `${input.tenantContext.serverPath}/`,
        tenant: input.tenantContext.tenant,
      },
      configuration: input.configuration,
    };
  }
}
